var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "billing-period-container" },
    _vm._l(_vm.periods, function (period, key) {
      return _c(
        "div",
        {
          key: key,
          staticClass: "billing-period-button",
          class: {
            active: key === _vm.value,
            "has-active": key !== "monthly" && _vm.getActivePlanCount(key) > 0,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("input", key)
            },
          },
        },
        [
          key !== "monthly" && _vm.getActivePlanCount(key) > 0
            ? _c("span", { staticClass: "active-plan-badge" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("billing.activePlansCount", {
                        count: _vm.getActivePlanCount(key),
                      })
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v("\n        " + _vm._s(period) + "\n        "),
          _vm.discount[key] > 0
            ? _c("span", { staticClass: "discount-badge" }, [
                _vm._v(_vm._s(_vm.discount[key]) + "%"),
              ])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }